module.exports = __webpack_public_path__ + "static/helm-symbol-SCAG-17451153add48c235e0d85cef1fb005a.webp";